<template>
  <div class="day-parts">
    <div class="day-parts__close" @click="clickHandler">Close <svg-icon :icon="closeIcon" :width="12" :height="12"></svg-icon></div>
    <day-parts-legend :parts="dayPartsConfig"
                      :selectedParts="selectedDayParts"
                      @day-part-click="dayPartSelected"></day-parts-legend>
    <div class="day-parts-comparison">
      <div class="day-parts-comparison__inner-container">
        <div class="day-parts-comparison__network" v-for="network in networksToShow">
          <h4 style="position:absolute; top:10px; left:30px;">{{ network.name }}</h4>
          <day-parts-graph :chart-data="removeHiddenDayParts(network.data)"
                           :axises="dayPartAxises"
                           class="workbench__day-break"
                           :width="380"
                           :height="140"></day-parts-graph>
         <div class="day-parts-comparison__x-mark" @click="deSelectNetwork(network.network)">
           &#10005;
         </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import DayPartsGraph from './DayPartsGraph'
  import DayPartsLegend from './DayPartsLegend.vue'
  import closeIcon from '@/assets/svg/cancel.svg'
  import SvgIcon from '@/components/common/svgIcon'
  import {
    transformViewershipDataForDayParts,
    extractDayPartsData,
    historicalViewershipGraphAxises
  } from '@/appComponents/workbench/lasGraphs/chartDataHelpers'
  import { filter } from 'lodash'
  import { REMOVE_FROM_SELECTED_DAY_PART_NETWORKS, REMOVE_ALL_DAY_PART_NETWORKS } from '@/appLogic/workbench/LAS/store/actions'

  export default {
    components: {
      DayPartsGraph,
      DayPartsLegend,
      SvgIcon
    },
    props: {
      // TODO need to update these values
      selectedNetworks: {
        type: Array,
        required: true
      },
      viewershipData: {
        type: Object,
        required: true
      },
      networks: {
        type: Array,
        required: true
      },
      dayPartsConfig: {
        type: Array,
        required: true
      }
    },
    data () {
      return {
        closeIcon,
        selectedDayParts: []
      }
    },
    methods: {
      clickHandler () {
        this.$store.dispatch('workbench/' + REMOVE_ALL_DAY_PART_NETWORKS)
      },
      dayPartSelected (id) {
        const alreadySelected = this.selectedDayParts.indexOf(id)
        if (alreadySelected > -1) {
          this.selectedDayParts.splice(alreadySelected, 1)
          return
        }
        this.selectedDayParts.push(id)
      },
      removeHiddenDayParts (chartData) {
        let filteredData = filter(chartData.datasets, dataset => {
          return this.selectedDayParts.indexOf(dataset.title) === -1
        })
        let data = {
          datasets: filteredData
        }
        return data
      },
      deSelectNetwork (network) {
        this.$store.dispatch('workbench/' + REMOVE_FROM_SELECTED_DAY_PART_NETWORKS, network)
      }
    },
    computed: {
      dayPartAxises () {
        return historicalViewershipGraphAxises(extractDayPartsData(this.viewershipData))
      },
      hydratedSelectedNetworks () {
        return this.selectedNetworks.map(networkId => {
          let network = this.networks.find(dayPart => dayPart.id === networkId)
          return network || {
            id: networkId,
            name: networkId
          }
        })
      },
      networksToShow () {
        return transformViewershipDataForDayParts(this.viewershipData, this.hydratedSelectedNetworks, this.dayPartsConfig)
      }
    }
  }
</script>

<style lang="scss">
  .day-parts {
    position: relative;
    overflow: auto;

    &__close {
      position: absolute;
      top: rem(18);
      left: rem(20);
      font-size: rem(16);
      line-height: rem(16);
      cursor: pointer;

      svg {
        width: rem(12) !important;
        height: rem(12) !important;
      }
    }

      &__export-button {
        padding-top: rem(18);
        text-align: right;

        .simple-button {
          padding-left: 16px;
          padding-right: 16px;
          font-weight: normal;
          background: black;
          display: inline-block;
        }
      }
  }

  .day-parts-comparison {
    background: #E8EBED;
    margin-top: rem(20);
    padding: rem(15);

    &__inner-container {
      display: flex;
      flex: 0 0;
      max-width: 100%;
      overflow-x: auto;
      overflow-y: hidden;
    }

    &__network {
      background: #ffffff;
      flex-shrink: 0;
      width: rem(340);
      padding: rem(10);
      margin-right: rem(15);
      position: relative;

      h4 {
        margin-top: 0;
        margin-bottom: rem(5);
        font-size: rem(16);
      }
    }

    &__x-mark {
      position: absolute;
      top: 4px;
      left: 8px;
      cursor: pointer;
      // font-weight: 700;
      font-size: rem(24);
    }

    &__x-mark:hover {
      color: color(blues, light);
    }
  }
</style>



// WEBPACK FOOTER //
// DayParts.vue?86fac030